module.exports = __webpack_public_path__ + "img/head_bg.371f600f.png";